import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Card from "../../components/ASTT Card/asttCard";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import AsttButton from "../../components/AsttButton/AsttButton";
import { searchTrainee } from "../../services/userServices";
import classes from "./RequisitionSearch.module.css";
import { generalStoreActions } from "../../Store/GeneralStore";
import { useDispatch } from "react-redux";
import BackdropComponent from "../../components/Spinner/Spinner";

const RequisitionSearch = () => {
  const { searchValue } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [userData, setUserData] = useState([]);
  const [loading, setLoader] = useState([false]);

  const ItemHeading = styled(Paper)(() => ({
    textAlign: "center",
    boxShadow: "none",
    fontWeight: 700,
  }));

  const Item = styled(Paper)(({ theme }) => ({
    textAlign: "center",
    boxShadow: "none",
  }));

  useEffect(() => {
    let cancelled = false;

    const fetchData = async () => {
      if (!cancelled) {
        setLoader(true);
      }

      try {
        const userDetails = await searchTrainee("RequisitionId", searchValue);

        if (cancelled) return;

        if (userDetails.status === true) {
          if (!cancelled) {
            setUserData(userDetails.data);
          }
        }
      } catch (error) {
        if (!cancelled) {
          console.error("Failed to search trainee:", error);
        }
      } finally {
        if (!cancelled) {
          setLoader(false);
        }
      }
    };

    fetchData();

    return () => {
      cancelled = true;
    };
  }, [searchValue]);

  const navigateRoster = (user) => {
    console.log(user);
    dispatch(generalStoreActions.updateClassRequestId(user.classRequestId));
    dispatch(generalStoreActions.updateClassRequestButton(false));
    const path = `/rosterSearch/null/${user.classRosterId}`;
    navigate(path);
  };

  return (
    <>
      {loading ? <BackdropComponent /> : null}
      <p className="p-10px fs-icon-class">{userData.length} ITEMS</p>
      <div className={classes.requisitionContainer}>
        {userData.length > 0 &&
          userData.map((user, i) => (
            <Card key={i}>
              <Grid container spacing={2}>
                <Grid item xs={8}>
                  <Grid container spacing={2}>
                    <Grid item xs={3}>
                      <ItemHeading>Class RosterId</ItemHeading>
                    </Grid>
                    <Grid item xs={3}>
                      <ItemHeading>Wave</ItemHeading>
                    </Grid>
                    <Grid item xs={3}>
                      <ItemHeading>Trainer</ItemHeading>
                    </Grid>
                    <Grid item xs={3}>
                      <ItemHeading>Tech Equp Solution</ItemHeading>
                    </Grid>
                  </Grid>
                  <Grid container spacing={2}>
                    <Grid item xs={3}>
                      <Item>{user.classRosterId}</Item>
                    </Grid>
                    <Grid item xs={3}>
                      <Item>{user.wave}</Item>
                    </Grid>
                    <Grid item xs={3}>
                      <Item>
                        <a
                          className="blackColor"
                          href={`mailto:${user.trainerEmail}`}
                        >
                          {user.trainerName}
                        </a>
                      </Item>
                    </Grid>
                    <Grid item xs={3}>
                      <Item>{user.techEquipmentSolution}</Item>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={4}>
                  <Item className={classes.widthbutton}>
                    <AsttButton
                      onClick={(e) => {
                        navigateRoster(user);
                      }}
                    >
                      View Details
                    </AsttButton>
                  </Item>
                </Grid>
              </Grid>
            </Card>
          ))}
        {userData.length === 0 && (
          <p className={classes.noData}>No Data Available</p>
        )}
      </div>
    </>
  );
};

export default RequisitionSearch;
